import { Divider, Grid, Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

export const Skills = () => {
  return (
    <Box>
        <Typography id="skills" variant="h5" fontWeight={600} sx={{mb:2}}>
            💻Skills
        </Typography>
        <Divider/>
        <Grid container spacing={5} sx={{mt:1}}>
            <Grid item xs={12} md={4}>
                <Paper variant="outlined" sx={{p: 5}}>
                    <Typography gutterBottom variant="h5" component="div" sx={{ mb: 3 }}>
                        Design
                    </Typography>
                    <Typography gutterBottom variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        This is not my strongest area but i do design.I 
                        focus mostly on figma as it is easy to use and also popular.
                        I'm committed to creating fluent user experiences while 
                        staying fashionable. 
                    </Typography>
                    <Box>
                        <img src="./images/figma.svg" alt="html" width="50" height="50" />
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper variant="outlined" sx={{p: 5}}>
                    <Typography gutterBottom variant="h5" component="div" sx={{ mb: 3 }}>
                        Frontend
                    </Typography>
                    <Typography gutterBottom variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        As a fullstack developer, I understand that the frontend is crucial 
                        as it is what the user sees. This is the reason  
                        why I have gone an extra mile to ensure that i am 
                        skilled in html5, css3, javascript and react  
                    </Typography>
                    <Box>
                        <img src="./images/html5.svg" alt="html" width="50" height="50" />
                        <img src="./images/css3.svg" width="50" height="50" alt="css" />
                        <img src="./images/javascript.svg" width="50" height="50" alt="javascript" />
                        <img src="./images/react.svg" width="50" height="50" alt="react" />
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper variant="outlined" sx={{p: 5}}>
                    <Typography gutterBottom variant="h5" component="div" sx={{ mb: 3 }}>
                        Backend
                    </Typography>
                    <Typography gutterBottom variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        My backend is also top notch as i have spent a lot of time
                        coding systems that require mastery of backend such as 
                        management systems. This has made me proficient in python 
                        and django. 
                    </Typography>
                    <Box>
                        <img src="./images/python.svg" alt="html" width="50" height="50" />
                        <img src="./images/django.svg" width="50" height="50" alt="css" />
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    </Box>
  )
}
